var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      attrs: { show: _vm.show },
      on: {
        close: function($event) {
          _vm.$emit("close")
        }
      }
    },
    [
      _c("div", { staticClass: "modal-header" }, [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                _vm.$emit("close")
              }
            }
          },
          [
            _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")]),
            _c("span", { staticClass: "sr-only" }, [_vm._v("Schließen")])
          ]
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "modal-title" }, [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "modal-body" },
        [_vm._t("default", [_c("p", [_vm._v(_vm._s(_vm.content))])])],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "modal-footer" }, [
        _c("div", { staticClass: "pull-left" }, [
          _c(
            "button",
            {
              staticClass: "btn-primary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$emit("close")
                }
              }
            },
            [_vm._v(_vm._s(_vm.cancel))]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pull-right" }, [
          _c(
            "button",
            {
              staticClass: "btn-secondary",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  _vm.$emit("confirm")
                }
              }
            },
            [
              _c("span", { staticClass: "fa fa-exclamation-triangle" }),
              _vm._v("\n        " + _vm._s(_vm.confirm) + "\n      ")
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5d6903d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d6903d4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalTokenConfirm.vue
// module id = null
// module chunks = 